import { BriefingConfigApi } from '@api/monitoring/model/briefing-config.api.model';
import { BaseModel } from '@Common/Basic/models/base.model';

export class BriefingConfig extends BaseModel<BriefingConfig, BriefingConfigApi> {

    alertLimit: number;
    activeAlertTotal: number;
    insightAutoGenerationBriefings: boolean;

    /** readonly */
    hasEngagementUpdates: boolean;

    public constructor(apiModel?: BriefingConfigApi) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: BriefingConfigApi) {
        this.alertLimit = apiModel.alertLimit;
        this.activeAlertTotal = apiModel.activeAlertTotal;
        this.insightAutoGenerationBriefings = apiModel.insightAutoGenerationBriefings;
        this.hasEngagementUpdates = apiModel.hasEngagementUpdates;
    }

    constructDefault() {
        this.alertLimit = 30;
        this.activeAlertTotal = 0;
    }

    toApiModel(): BriefingConfigApi {
        return {
            alertLimit: this.alertLimit,
            activeAlertTotal: this.activeAlertTotal,
            insightAutoGenerationBriefings: this.insightAutoGenerationBriefings
        };
    }

    clone(): BriefingConfig {

        const clone = new BriefingConfig({
            ...this.toApiModel(),
            hasEngagementUpdates: this.hasEngagementUpdates
        });

        return clone;
    }

    equals(other?: BriefingConfig): boolean {
        if (!other) {
            return false;
        }

        if (this.alertLimit !== other.alertLimit) {
            return false;
        }

        if (this.activeAlertTotal !== other.activeAlertTotal) {
            return false;
        }

        if (this.insightAutoGenerationBriefings !== other.insightAutoGenerationBriefings) {
            return false;
        }

        if (this.hasEngagementUpdates !== other.hasEngagementUpdates) {
            return false;
        }

        return true;
    }
}
